import { FormattedMessage } from 'react-intl'
import { getRouteApi, Link as LinkComponent } from '@tanstack/react-router'

import { Alert } from '@gto/ui/alert'
import { IconRakebackWizardLogoSigned } from '@gto/ui/assets'
import { Button } from '@gto/ui/button'
import { Link } from '@gto/ui/link'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

const routeApi = getRouteApi('/_auth/login/oauth/')

export const OAuthCodeCheckRoute = () => {
  const data = routeApi.useLoaderData()

  if (data.status === 'error') {
    return (
      <div className="flex size-full flex-col items-center justify-center gap-6 p-4">
        <IconRakebackWizardLogoSigned height={50} />
        <Paper
          className="w-full max-w-[500px] rounded-md border border-divider p-6"
          elevation="2"
        >
          <div className="flex flex-col gap-8">
            <div className="text-center">
              <Typography
                component="p"
                variant="h4"
              >
                <FormattedMessage id="errorBoundary.oops" />
              </Typography>
            </div>

            <Alert
              heading={<FormattedMessage id="auth.oauth.error.alt" />}
              severity="error"
              actions={[
                {
                  children: window.location.origin,
                  href: '/login?type=implicit',
                  component: Link,
                },
              ]}
            />

            <Button
              color="primary"
              component={LinkComponent}
              size="large"
              to="/"
              variant="contained"
            >
              <FormattedMessage id="common.controls.backToHome" />
            </Button>
          </div>
        </Paper>
      </div>
    )
  }
}
